import { EnhancedPlan } from '@mm/state/interfaces/subscription';
import classNames from 'classnames';
import React from 'react';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import styles from './BillingPlans.module.css';
import { BillingPlanCardProps } from './use-billing-plans';

export type Props = {
  option: BillingPlanCardProps;
  getOptionParams: (option: BillingPlanCardProps) => {
    downgrade?: EnhancedPlan;
    currentTag?: boolean;
    buttonNameAdjusted?: string;
  };
  className?: string;
  isAgency?: boolean;
};

export const Plan = ({
  option,
  getOptionParams,
  className,
  isAgency,
}: Props) => {
  const { downgrade, currentTag, buttonNameAdjusted } = getOptionParams(option);
  return (
    <div
      id={option.planCode ? `billing-plan__${option.planCode}` : undefined}
      className={classNames(styles.mainBlock, className)}
    >
      <div
        className={classNames(styles.heading, {
          [styles.agencyHeading]: isAgency,
        })}
      >
        {option.title}
      </div>
      <div className={classNames(styles.priceBlock)}>
        <span className={styles.startsAt}>
          {option.price ? 'Starts at:' : ''}
        </span>
        <div className={classNames(styles.price)}>
          <div className={styles.priceContainer}>
            <span className={styles.priceValue}>{option.price}</span>
            <div className={styles.pricePeriodBlock}>
              <span className={styles.pricePeriod}>{option.pricePeriod}</span>
              <span className={styles.pricePeriod} style={{ fontWeight: 700 }}>
                {option.priceNote}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.buttonsContainer}>
        {option.buttonComponent ? (
          option.buttonComponent(!!currentTag)
        ) : (
          <PrimaryButton
            className={classNames(styles.button, {
              [styles.secondaryButton]: downgrade,
              [styles.disabledButton]: currentTag || option.isFreeTrial,
            })}
            onClick={option.onClick}
            disabled={currentTag || option.isFreeTrial}
          >
            {buttonNameAdjusted}
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};
